import { __decorate } from "tslib";
import FeedbackCategories from '@/entities/enums/FeedbackCategories';
import { UserSettingsKeys } from '@/entities/enums/UserSettingKeys';
import SalesRepository from '@/services/repository/SalesRepository';
import UserSettingsRepository from '@/services/repository/UserSettingsRepository';
import VueUtilities from '@/services/VueUtilities';
import { Component, Vue } from 'vue-property-decorator';
var userSettingsRepository;
var salesRepository;
let RateUsPopup = class RateUsPopup extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.rate = null;
        this.buttonkey = 0;
        this.feedbackText = '';
    }
    async created() {
        userSettingsRepository = UserSettingsRepository.getInstance(this);
        salesRepository = new SalesRepository(this);
    }
    resultRetrieved(isNeedToSave) {
        this.$emit('modalClosed', isNeedToSave);
    }
    rateUs() {
        this.$validator.validateAll().then(async (result) => {
            if (result) {
                this.submitUserRating(this.rate);
            }
            else {
                this.buttonkey++;
            }
        });
    }
    async submitUserRating(rating) {
        let data = {
            Text: JSON.stringify(this.feedbackText
                ? {
                    rating,
                    message: this.feedbackText
                }
                : { rating }),
            Category: FeedbackCategories.USER_RATING.name,
            Subject: this.$t('component.rateUsModal.subject')
        };
        this.isLoading = true;
        let allPromises = [];
        allPromises.push(await userSettingsRepository.saveUserSettings([
            [UserSettingsKeys.USERRATING, UserSettingsKeys.ISSUBMITTED],
            [UserSettingsKeys.USERRATING, UserSettingsKeys.LASTSHOWNTIMESTAMP]
        ], [true, Date.now()]));
        allPromises.push(salesRepository.sendFeedback(data));
        Promise.all(allPromises).then((response) => {
            if (response[1] === true) {
                VueUtilities.openSuccessToast(this, this.$t('component.rateUsModal.success').toString());
                this.$eventBus.$emit('changeRateUsBtnState', true);
                this.resultRetrieved(false);
            }
            else {
                this.buttonkey++;
                VueUtilities.openErrorToast(this, this.$t('contact_form.failure'));
            }
            this.isLoading = false;
        });
    }
};
RateUsPopup = __decorate([
    Component({ components: {} })
], RateUsPopup);
export default RateUsPopup;
